import React from 'react';
import ReactDOM from 'react-dom/client';
import CaffeineTracker from './components/CaffeineTracker';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    
    <CaffeineTracker />
  </React.StrictMode>
);
